import React from "react";
import styled, { keyframes } from "styled-components";

const rotate = keyframes`
	0% {
		transform: rotate(0deg);
	}
	50% {
		transform: rotate(180deg);
	}
	100% {
		transform: rotate(360deg);
	}
`;

const Container = styled.div`
  position: relative;
  width: 20rem;
  height: 20rem;
`;

const Inner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  animation: ${rotate} 1.5s linear infinite;
  border-radius: 50%;
  box-shadow: 0 4px 0 0 ${props => props.theme.palette.primary};
`;

const Loader = () => {
  return (
    <Container>
      <Inner />
    </Container>
  );
};

export default Loader;
